import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=20d344f2&scoped=true&"
import script from "./Blogs.vue?vue&type=script&lang=ts&"
export * from "./Blogs.vue?vue&type=script&lang=ts&"
import style0 from "./Blogs.vue?vue&type=style&index=0&id=20d344f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d344f2",
  null
  
)

export default component.exports